import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Entreprise } from 'src/app/models/entreprise.model';
import { PortfolioService } from '../portfolio.service';


@Component({
  selector: 'app-entreprise',
  templateUrl: './entreprise.component.html',
  providers: [PortfolioService],
  styleUrls: ['./entreprise.component.css']
})
export class EntrepriseComponent implements OnInit {
  entreprise: Entreprise;
  id: number;
  constructor(private route: ActivatedRoute, private portfolioService: PortfolioService) {
  }

  ngOnInit() {
    this.id = this.route.snapshot.params['id'];
    this.portfolioService.getEntreprise(this.id)
      .subscribe(entreprise => {
        this.entreprise = entreprise
      }
      );

  }

}
